module.exports = __webpack_public_path__ + "img/12.2eaff6ef.png";